interface ISiteLabelCheckboxConfig
    extends ISiteLabelConfig
{
    isNullable: boolean;
}

class SiteLabelCheckbox 
    extends SiteLabel<boolean, ISiteLabelCheckboxConfig> {

    private _input: IQueryElement;
    private _value: boolean | null;

    constructor(card: SiteCard, model: ISiteModel, modelData: ISiteModel, element: HTMLElement) {
        super(card, model, modelData, element);
        let input = this.query("input").first();

        if(input === null)
            throw 'SiteLabelInput: Missing element(s)';
        
        this._value = null;
        this._input = input;

        this._input.on("change", () => {
            if (this.config.isNullable) {
                if (this._value === null)
                    this._value = true;
                else if (this._value === true)
                    this._value = false;
                else
                    this._value = null;
            } else {
                if (this._value === true)
                    this._value = false;
                else
                    this._value = true;
            }
            this.setValue(this.getValue());
        });
    }
    getInput() {
        return this._input;
    }
    
    defaultConfig(): ISiteLabelCheckboxConfig {
        return {
            popout: "normal",
            isNullable: false,
            scroll: "top"
        }
    }

    getValue() {
        return this._value;
    }
    setValue(value: boolean | null) {
        let element = this._input.get();
        this._value = value;
        
        if(element instanceof HTMLInputElement) {
            element.indeterminate = false;
            if(this._value == null)
                element.indeterminate = true;
            else if(this._value === true) 
                element.checked = true;
            else
                element.checked = false;
        }

        super.setValue(this._value);
    }
} 